import React from 'react'
import { useLocation } from 'react-router-dom'
import { Presenter, Props } from './presenter'

import { useGetErrorStatus } from '../../../errorHandler'

function Container({ children }: Props) {
  const { pathname } = useLocation()
  const errorStatus = useGetErrorStatus()

  return (
    <Presenter backgroundImg={pathname === '/' && (errorStatus === 0 || errorStatus === 200)}>{children}</Presenter>
  )
}

export { Container }
